import { render } from "./Contracts.vue?vue&type=template&id=6f1c310a&scoped=true"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"

import "./Contracts.vue?vue&type=style&index=0&id=6f1c310a&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1c310a"]])

export default __exports__